import { render } from "./fugaoyixuejishu-news.vue?vue&type=template&id=6dc826ff&scoped=true"
import script from "./fugaoyixuejishu-news.vue?vue&type=script&lang=js"
export * from "./fugaoyixuejishu-news.vue?vue&type=script&lang=js"

import "./fugaoyixuejishu-news.vue?vue&type=style&index=0&id=6dc826ff&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc826ff"]])

export default __exports__